import { pixelToDxa } from '@/libs/utils/docxUtils'
import {
  AlignmentType,
  PageBreak,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
} from 'docx'
import { tableIndentedWidthDxa } from '../../constants'

const getCellProps = ({ color, value, children }) => ({
  margins: { top: 100, bottom: 100, left: 100, right: 100 },
  verticalAlign: VerticalAlign.CENTER,
  shading: { fill: color },
  children: children || [new Paragraph({ children: value, alignment: AlignmentType.CENTER })],
})

const Row = ({ first = [], second = [], third = [], color = 'FFFFFF' }) =>
  new TableRow({
    height: { value: pixelToDxa(40) },
    children: [
      new TableCell({
        ...getCellProps({ color, value: first }),
      }),
      new TableCell({
        ...getCellProps({ color, value: second }),
      }),
      new TableCell({
        ...getCellProps({ color, value: third }),
      }),
    ],
  })

const Chapter3Page = ({ reportData }) => {
  const { notYetFinishData, trainingListData } = reportData || {}

  const data1 = trainingListData || []
  const data2 = notYetFinishData || []

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph({
      style: 'textParagraph',
      children: [new TextRun('附件一 訓練名單')],
    }),
    new Paragraph(''),
    new Table({
      columnWidths: [
        tableIndentedWidthDxa / 3,
        tableIndentedWidthDxa / 3,
        tableIndentedWidthDxa / 3,
      ],
      width: { size: tableIndentedWidthDxa, type: WidthType.DXA },
      rows: [
        Row({
          first: [new TextRun({ text: '姓名', bold: true })],
          second: [new TextRun({ text: '單位', bold: true })],
          third: [new TextRun({ text: '郵件', bold: true })],
        }),
        ...data1.map(d =>
          Row({
            first: [new TextRun(d.userName || '')],
            second: [new TextRun(d.unit || '')],
            third: [new TextRun(d.email || '')],
          }),
        ),
      ],
    }),

    new Paragraph(''),

    new Paragraph({
      style: 'textParagraph',
      children: [new TextRun('附件二 未完成訓練名單')],
    }),
    new Paragraph(''),
    new Table({
      columnWidths: [
        tableIndentedWidthDxa / 3,
        tableIndentedWidthDxa / 3,
        tableIndentedWidthDxa / 3,
      ],
      width: { size: tableIndentedWidthDxa, type: WidthType.DXA },
      rows: [
        Row({
          first: [new TextRun({ text: '姓名', bold: true })],
          second: [new TextRun({ text: '單位', bold: true })],
          third: [new TextRun({ text: '郵件', bold: true })],
        }),
        ...data2.map(d =>
          Row({
            first: [new TextRun(d.userName || '')],
            second: [new TextRun(d.unit || '')],
            third: [new TextRun(d.email || '')],
          }),
        ),
      ],
    }),
  ]
}

export default Chapter3Page
